import { ChatbotProvider, useChatbot } from "@ac-expo/hooks";
import { ChatbotOverlay } from "@ac-expo/ui-components";
import { RagFaqPlatform } from "@prisma/client";
import { useUserContext } from "./auth/user.context";
import { useWebSocket } from "./websocket/websocket.context";

export const ChatbotAdapter = () => {
  const ws = useWebSocket();
  const { user } = useUserContext();

  if (!user) {
    return null;
  }

  return (
    <ChatbotProvider ws={ws} messages={[]} app={RagFaqPlatform.webApp}>
      <Chatbot />
    </ChatbotProvider>
  );
};

const Chatbot = () => {
  const ctx = useChatbot();

  return <ChatbotOverlay context={ctx} className="fixed" />;
};
